export const DatesFilters = {

	/*
	**  Set up the filters
	*/

	filters: {

		monthDayYear: function(value) {

			return moment(value, 'YYYY-MM-DDThh:mm:ss-5:00').format('MM/DD/YYYY');

		},

		month: function(value) {

			return moment(value, 'YYYY-MM-DDThh:mm:ss-5:00').format('MMMM');

		},

		unixToDate: function(value) {

			return moment(value * 1000).format('MM/DD/YYYY');

		},

		unixToMonthShorthand: function(value) {

			return moment(value * 1000).format('MMM');

		},

		unixToMonth: function(value) {

			return moment(value * 1000).format('MMMM');

		},

		unixToYear: function(value) {

			return moment(value * 1000).format('YYYY');

		},

		unixToDateTime: function(value) {

			return moment(value * 1000).format('MM/DD/YYYY - hh:mm:ss A');

		}

	}

}